/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для виджета выбора даты
   */
  app.DatepickerView = app.View.extend({
    additionalOptions: ['dateFormat'],
    run: function () {
      // Устанавливаем дефолтные параметры
      $.datepicker.setDefaults({
        showOtherMonths: true,
        selectOtherMonths: true,
        dateFormat: this.dateFormat || 'dd.mm.yy',
        closeText: 'Закрыть',
        prevText: '&#x3c;Пред',
        nextText: 'След&#x3e;',
        currentText: 'Сегодня',
        monthNames: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь'
        ],
        monthNamesShort: [
          'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
          'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        dayNames: [
          'воскресенье',
          'понедельник',
          'вторник',
          'среда',
          'четверг',
          'пятница',
          'суббота'
        ],
        dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
        dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        weekHeader: 'Не',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''
      });
    },

    /**
     * Возвращает элемент виджета выбора даты
     * @returns {jQuery}
     */
    getDpElement: function () {
      return $.datepicker.dpDiv;
    }
  });
})(jQuery);

}.call(window));